<template>
  <div class="recent-reviews">
    <span>Recent Reviews</span>
    <div class="review-list">
      <review-list-item v-for="review in recentReviews" :key="review.id" :review="review"/>
    </div>
  </div>
</template>

<script>
  import ReviewListItem from "./ReviewListItem";

  export default {
    name: "ReviewHighlights",
    components: {ReviewListItem},
    computed: {
      recentReviews() {
        return this.$store.getters.recentReviews;
      }
    },
  }
</script>

<style lang="scss" scoped>
  .recent-reviews {
    padding: 16px;

    .review-list {
      margin-top: 15px;
      display: flex;
      flex-direction: column;
    }
  }
</style>
